import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import axios from "axios";

import Carousel from "../Catalog/Carousel";
import SellerItem from "./Item";

const DEFAULT_FILTERS = [
    {
        field: "logo_pic",
        value: "null",
        condition: "neq"
    },
    {
        field: "logo_pic",
        value: "",
        condition: "notnull"
    },
    {
        field: "shop_title",
        value: "",
        condition: "notnull"
    },
    {
        field: "is_seller",
        value: "1"
    }
];

const SellerWidget = ({
    title,
    pageSize,
    filterGroups,
    customerFilterGroups,
    sortOrders,
    pageCount,
    pageScroll,
    showDetails,
    autoPlay,
    autoPlayInterval,
    speed,
    loop
}) => {
    const [sellers, setSellers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [activeFilterGroups] = useState([
        ...DEFAULT_FILTERS,
        ...filterGroups
    ]);

    useEffect(() => {
        if (
            customerFilterGroups &&
            Array.isArray(customerFilterGroups) &&
            customerFilterGroups.length > 0
        ) {
            (() => {
                fetchSellerIdsByCustomerFilter().then(
                    activeFilterGroupsWithCustomerFilters => {
                        fetchSellers(activeFilterGroupsWithCustomerFilters);
                    }
                );
            })();
        } else {
            fetchSellers(activeFilterGroups);
        }
    }, [
        fetchSellers,
        fetchSellerIdsByCustomerFilter,
        customerFilterGroups,
        activeFilterGroups
    ]);

    const fetchSellerIdsByCustomerFilter = useCallback(() => {
        return axios
            .get("/api/customers/search", {
                params: {
                    filterGroups: JSON.stringify(customerFilterGroups),
                    pageSize: 9999,
                    fields: "items[id]"
                }
            })
            .then(({ data }) => {
                return [
                    ...activeFilterGroups,
                    {
                        field: "seller_id",
                        value: data.items.map(({ id }) => id).join(","),
                        condition: "in"
                    }
                ];
            })
            .catch(err => console.error(err));
    }, [activeFilterGroups, customerFilterGroups]);

    const fetchSellers = useCallback(
        activeFilterGroupsWithCustomerFilters => {
            axios
                .get("/api/sellers/search", {
                    params: {
                        filterGroups: JSON.stringify(
                            activeFilterGroupsWithCustomerFilters
                        ),
                        sortOrders: JSON.stringify(sortOrders),
                        pageSize: pageSize * pageCount,
                        fields: [
                            "response[sellers[seller_id,shop_url,logo_pic,shop_title]]"
                        ]
                    }
                })
                .then(({ data }) => {
                    setSellers(data.sellers);
                    setIsLoading(false);
                })
                .catch(err => {
                    console.error(err);
                    setIsLoading(false);
                });
        },
        [sortOrders, pageSize, pageCount]
    );

    return (
        sellers &&
        sellers.length > 0 && (
            <div className="seller-widget">
                {title && <h2 className="title"> {title} </h2>}
                <Carousel
                    showDetails={showDetails}
                    data={sellers}
                    itemComponent={SellerItem}
                    pageSize={pageSize}
                    pageScroll={pageScroll}
                    loop={loop}
                    speed={speed}
                    autoPlay={autoPlay}
                    autoPlayInterval={autoPlayInterval}
                    isLoading={isLoading}
                    className="seller-grid"
                />
            </div>
        )
    );
};

SellerWidget.defaultProps = {
    template: "grid",
    data: [],
    filterGroups: [],
    customerFilterGroups: [],
    sortOrders: [],
    showDetails: true,
    pageSize: 4,
    pageCount: 3,
    pageScroll: 4,
    autoPlay: false,
    autoPlayInterval: 3000,
    speed: 500,
    loop: true
};

SellerWidget.propTypes = {
    title: PropTypes.string,
    data: PropTypes.array,
    filterGroups: PropTypes.array,
    customerFilterGroups: PropTypes.array,
    sortOrders: PropTypes.array,
    showDetails: PropTypes.bool,
    pageSize: PropTypes.number,
    pageCount: PropTypes.number,
    pageScroll: PropTypes.number,
    autoPlay: PropTypes.bool,
    autoPlayInterval: PropTypes.number,
    speed: PropTypes.number,
    loop: PropTypes.bool
};

export default SellerWidget;
